import { Flex } from "../../../styled";
import { ActionIcon, TextInput } from "@mantine/core";
import { IconX } from "@tabler/icons-react";

interface Props {
  value: string;
  onChange: (value: string) => void;
  containerStyles?: React.CSSProperties;
  icon?: React.ReactNode;
  label?: string;
}

const SearchInput = ({
  value,
  onChange,
  containerStyles,
  icon,
  label,
}: Props) => {
  return (
    <Flex
      align="center"
      gap={5}
      style={containerStyles}
      mx={10}
      justify="flex-start">
      <TextInput
        value={value}
        onChange={e => onChange(e.target.value)}
        style={{ flex: 1 }}
        placeholder={label ?? "Search item"}
        rightSection={
          icon &&
          (value.trim().length > 0 ? (
            <ActionIcon onClick={() => onChange("")}>
              <IconX color="#ff6b6b" />
            </ActionIcon>
          ) : (
            icon
          ))
        }
      />
      {!icon &&
        (value.trim().length > 0 ? (
          <ActionIcon onClick={() => onChange("")} w={30}>
            <IconX color="#ff6b6b" />
          </ActionIcon>
        ) : (
          <div style={{ width: 30 }} />
        ))}
    </Flex>
  );
};
export default SearchInput;
